import { Modes } from '@constants/canvas/layers';

/**
 * AC1.1: the Share filters pill exists only where there are two modes to
 * share between. Cyber resilience has no model filters, so a tier that pairs
 * it with a single filterable mode offers nothing to share, and neither does
 * a single-mode tier. An unloaded subscription offers nothing yet.
 */
export const isShareFiltersOffered = (
  modes: ReadonlyArray<Modes> | undefined,
): boolean =>
  modes !== undefined &&
  modes.includes(Modes.BusinessAlignment) &&
  modes.includes(Modes.Controls);
